import $ from 'jquery'
import Isotope from 'isotope-layout'
import jQueryBridget from 'jquery-bridget'
import rangeSlider from './../modules/rangeSlider'
import slideShowSlider from '../modules/sliders/slideShowSlider'
import ComparisonsImagesSlider from '../modules/comparisonSlider'
import AOS from 'aos'
import 'aos/dist/aos.css'
import PhoneParalax from '../animations/PhoneParalax'
import simpleParallax from 'simple-parallax-js'
import TextParalax from '../animations/TextParalax'

window.addEventListener('DOMContentLoaded', () => {
  rangeSlider()
  slideShowSlider()
  jQueryBridget('isotope', Isotope, $)
  const grid = $('.case-study .portfolioGrid')
  if (grid) {
    grid.isotope({
      itemSelector: '.portfolioGridItem',
      percentPosition: true,
      filter: '.chosen',
      masonry: {
        columnWidth: '.portfolioGridSizer'
      }
    })
  }

    AOS.init()
    document.addEventListener('lazybeforeunveil', () => AOS.refresh())


  new PhoneParalax()
  new TextParalax()

  const elems = document.querySelectorAll('[data-aos]')
  if (elems.length) {
    elems.forEach(el => el.parentElement.classList.add('hide-overflow-mobile'))
  }
})

const parallaxImages = document.querySelectorAll('.bg-af')
if (parallaxImages) new simpleParallax(parallaxImages)

window.addEventListener('load', () => {
  new ComparisonsImagesSlider()
})
